import script from "./CookieConsentModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CookieConsentModal.vue?vue&type=script&setup=true&lang=ts"

import "./CookieConsentModal.vue?vue&type=style&index=0&id=5669fc3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5669fc3a"]])

export default __exports__